import React from 'react';
import { FadeIn } from './FadeIn';
import { MapIcon, MessageCircleIcon, CalendarDaysIcon } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    icon: MapIcon,
    title: 'Mapa Rápido de Bloqueos Matemáticos',
    desc: 'Detectá en 15 minutos qué frena a tu hijo y qué hacer primero.',
    value: '$4.990'
  }, {
    icon: MessageCircleIcon,
    title: 'Guía de Frases que Calman y Enseñan',
    desc: 'Las palabras exactas para cada momento difícil de la tarea.',
    value: '$4.990'
  }, {
    icon: CalendarDaysIcon,
    title: 'Plan Express de 7 Días',
    desc: 'Una micro acción por día para crear victorias desde la primera semana.',
    value: '$4.990'
  }];
  return <section className="py-14 md:py-20 relative bg-background" data-id="element-19">
      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-20">
        <FadeIn data-id="element-21">
          <div className="text-center mb-10" data-id="element-22">
            <h2 className="font-heading text-3xl md:text-5xl font-extrabold mb-3 text-slate-900" data-id="element-23">
              🎁 LOS 3 BONOS EXCLUSIVOS
            </h2>
            <p className="text-amber-dark text-base font-bold uppercase tracking-widest mb-3" data-id="element-24">
              Siempre incluidos
            </p>
            <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-25">
              Tres herramientas prácticas, listas para usar. Sin relleno.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-8" data-id="element-26">
          {bonuses.map((bono, i) => {
          const Icon = bono.icon;
          return <FadeIn key={i} delay={i * 0.1} data-id="element-27">
                <div className="bg-white p-5 rounded-2xl shadow-soft border border-slate-100 hover:shadow-soft-lg transition-all duration-300 h-full flex flex-col" data-id="element-28">
                  <div className="flex items-center justify-between gap-3 mb-3" data-id="element-29">
                    <div className="flex items-center gap-2.5 min-w-0" data-id="element-30">
                      <div className="w-10 h-10 rounded-xl bg-amber/10 flex items-center justify-center shrink-0" data-id="element-31">
                        <Icon className="w-5 h-5 text-amber-dark" data-id="element-32" />
                      </div>
                      <span className="font-heading text-base font-extrabold text-amber-dark whitespace-nowrap" data-id="element-33">
                        Bono {i + 1}
                      </span>
                    </div>
                    <div className="flex items-center gap-2 shrink-0" data-id="element-34">
                      <span className="text-slate-400 line-through text-xs font-bold hidden sm:inline" data-id="element-35">
                        {bono.value}
                      </span>
                      <span className="bg-amber text-white font-extrabold px-3 py-1 rounded-lg text-xs uppercase tracking-wider shadow-sm" data-id="element-36">
                        GRATIS
                      </span>
                    </div>
                  </div>
                  <h3 className="font-heading text-base font-extrabold text-slate-900 mb-1.5 leading-tight" data-id="element-37">
                    {bono.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-snug" data-id="element-38">
                    {bono.desc}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>

        <FadeIn delay={0.4} data-id="element-39">
          <div className="text-center p-6 md:p-7 rounded-3xl bg-amber/10 border border-amber/20" data-id="element-40">
            <p className="text-lg md:text-xl font-bold text-slate-900" data-id="element-41">
              Valor total de los 3 Bonos:{' '}
              <span className="line-through text-slate-500 mx-1" data-id="element-42">$14.970</span>{' '}
              <span className="text-amber-dark font-extrabold" data-id="element-43">
                → GRATIS en las dos opciones
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}